// react
import { createContext } from 'react';

// types
import type { ShortcutContextProps } from './ShortcutProvider.types';

export const ShortcutContext = createContext<ShortcutContextProps>({
  createShortcutContext: undefined,
  enableShortcut: undefined,
  disableShortcut: undefined,
  register: undefined,
  unregister: undefined,
  setActiveShortcutContexts: undefined,
  shortcuts: {}
});
